import { render, staticRenderFns } from "./AirwayPanel.vue?vue&type=template&id=6117ec58&scoped=true&"
import script from "./AirwayPanel.vue?vue&type=script&lang=js&"
export * from "./AirwayPanel.vue?vue&type=script&lang=js&"
import style0 from "./AirwayPanel.vue?vue&type=style&index=0&id=6117ec58&prod&lang=css&"
import style1 from "./AirwayPanel.vue?vue&type=style&index=1&id=6117ec58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117ec58",
  null
  
)

export default component.exports